import React from 'react';
import { COLORS, SPACING } from './constants';
import { CompleteContainer, CompleteButton } from './SharedStyles';

const COMPLETION_CONTENT = {
  title: 'Thanks for your review!',
  description1: 'Your thoughts will help others find the perfect product.',
  description2: 'We truly appreciate you taking the time!',
  buttonText: 'Continue Shopping',
} as const;

const CompletionContent = () => (
  <div className="flex flex-col gap-4 items-start w-full">
    <p className="text-paragraph-large font-semibold text-neutral-800">{COMPLETION_CONTENT.title}</p>
    <p className="text-label-medium text-neutral-600">{COMPLETION_CONTENT.description1}</p>
    <p className="text-label-medium text-neutral-600">{COMPLETION_CONTENT.description2}</p>
  </div>
);

interface CompleteViewProps {
  onContinue: () => void;
  variant: 'pc' | 'mobile';
}

export const CompleteView = ({ onContinue, variant }: CompleteViewProps) => {
  const handleContinue = () => {
    onContinue();
    window.location.href = '/shop/';
  };

  if (variant === 'mobile') {
    return (
      <>
        <CompleteContainer
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            textAlign: 'left',
            paddingBottom: '80px',
          }}
        >
          <CompletionContent />
        </CompleteContainer>
        <div
          className="fixed left-0 right-0 bottom-0 w-full box-border"
          style={{
            background: COLORS.background,
            padding: `${SPACING.lg} ${SPACING.lg} 68px ${SPACING.lg}`,
          }}
        >
          <CompleteButton onClick={handleContinue}>
            <span className="text-paragraph-small font-medium text-generic-0">{COMPLETION_CONTENT.buttonText}</span>
          </CompleteButton>
        </div>
      </>
    );
  }

  return (
    <div className="flex flex-col gap-12 w-full">
      <CompletionContent />
      <CompleteButton onClick={handleContinue}>
        <span className="text-paragraph-small font-medium text-generic-0">{COMPLETION_CONTENT.buttonText}</span>
      </CompleteButton>
    </div>
  );
};
